var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4002 6.34275L4.13337 2.5946",
    stroke: "#FF5400",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0337 11.1091V5.33163C15.0334 5.07834 14.9587 4.82957 14.817 4.61029C14.6752 4.391 14.4715 4.20889 14.2263 4.08225L8.57429 1.19351C8.3288 1.06674 8.05033 1 7.76686 1C7.48339 1 7.20492 1.06674 6.95943 1.19351L1.30743 4.08225C1.06218 4.20889 0.858482 4.391 0.716764 4.61029C0.575045 4.82957 0.50029 5.07834 0.5 5.33163V11.1091C0.50029 11.3624 0.575045 11.6112 0.716764 11.8305C0.858482 12.0497 1.06218 12.2318 1.30743 12.3585L6.95943 15.2472C7.20492 15.374 7.48339 15.4407 7.76686 15.4407C8.05033 15.4407 8.3288 15.374 8.57429 15.2472L14.2263 12.3585C14.4715 12.2318 14.6752 12.0497 14.817 11.8305C14.9587 11.6112 15.0334 11.3624 15.0337 11.1091Z",
    stroke: "#FF5400",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.717873 4.58057L7.76673 8.2276L14.8156 4.58057",
    stroke: "#FF5400",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.76673 15.5V8.22034",
    stroke: "#FF5400",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.0615b2d93cde5859f6178143ec8fd050.svg";
export { ForwardRef as ReactComponent };